<template>
    <IndexBase @auth="onAuth($event)" action="Transporter" controller="Upload"></IndexBase>

    <Card>
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title">
                        {{$t('upload_transporter')}}
                    </div>
                </template>
            </Toolbar>
        </template>
        <template #content>            
            <div class="grid">
                <div class="col-12">
                    <FormField :labelName="$t('upload_file')" v-model="dataUrl" labelClass="col-2" fieldClass="col-6 md-6">
                        <CustomFileUpload 
                            :multiple="false"
                            mode="basic" 
                            :showUploadButton="false" 
                            :showCancelButton="false" 
                            :customUpload="false" 
                            @select="onFileSelect" 
                            @clear="onFileClear"
                            accept=".xlsx"
                            />

                        
                    </FormField>
                    <FormField labelName="" v-model="dataUrl" labelClass="col-2" fieldClass="col-6 md-6">
                        <a href="/templates/upload_transporter.xlsx" download>
                            <Button icon="pi pi-download" class="p-button p-button-help mr-1" label="Download Template"></Button>
                        </a>



                        <Button v-if="podFiles != null && podFiles.length > 0" icon="pi pi-save" class="p-button p-button-success mr-1" label="Upload" @click="uploadFile()"></Button>
                    </FormField>

                    <Message severity="info" :closable="true" v-if="errorMessage" @close="closeMessage">{{errorMessage}}</Message>
                </div>
            </div>
        </template>
    </Card>

   
</template>

<script>
    import IndexBase from '../Helper/IndexBase.vue'
    
    export default {
        name: "UploadTransporter",
        components: {
            'IndexBase': IndexBase
        },
        data() {
            return {
                dataModel: null,
                loading: true,
                totalRecords: 0,
                start: 0,
                stateKey: 'itm-state-upload-transporter-' + this.$store.getters.getUsername,
                role: this.$store.getters.getRole,
                isAdmin: this.$store.getters.getIsAdmin,
                isUser: this.$store.getters.getIsUser,
                isTransporter: this.$store.getters.getIsTransporter,
                isDriver: this.$store.getters.getIsDriver,
                dataUrl: "upload/upload_transporter_data",
                canCreate: false,
                canEdit: false,
                canDelete: false,
                canView: false,
                podNotes: "",
                podFiles: [],
                viewPODFiles: null,
                errorMessage:""
            }
        },
        methods: {
            onAuth(event) {
                this.canCreate = event.canCreate;
                this.canEdit = event.canEdit;
                this.canDelete = event.canDelete;
                this.canView = event.canView;
            },
            onFileSelect(event){
                this.podFiles = event.files;
            },
            onFileRemove(files){
                this.podFiles = files;
            },
            onFileClear(){
                this.podFiles = [];
            },
            uploadFile(){
                var self = this;

                self.$emit("block-ui");

                var data = new FormData();
                for(var i=0; i< this.podFiles.length;i++){
                    data.append("file", this.podFiles[i], this.podFiles[i].name);
                }

                this.$axios.put(this.$API_URL + this.dataUrl, data,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((response) =>{
                        if (response.data.success) {
                            self.errorMessage = response.data.data;
                            self.$parent.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: 120000});
                            self.showModal = false;
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }

                        self.blocked = false;
                        self.$emit("unblock-ui");

                    }).catch((err) => {
                        console.log(err);
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err, life: 120000});
                        self.blocked = false;
                        self.showModal = false;
                        self.$emit("unblock-ui");

                    });

            },
            closeMessage(){
                this.errorMessage = "";
            }
        },
        mounted() {
            this.$emit('unblock-ui');
        },
        computed: {
            dataFilter() {
                var h = [];
                if (this.filters) {
                    for (const [key, value] of Object.entries(this.filters)) {
                        h.push({
                            field: key ? key : null,
                            value: value.value,
                            matchMode: value.matchMode
                        });
                    }
                }
                return h;
            },
            dataSort() {
                var h = [];
                if (this.sorts) {
                    for (var x = 0; x < this.sorts.length; x++) {
                        h.push({
                            field: this.sorts[x].field,
                            order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                        });
                    }
                }
                return h;
            },
            filterBadge(){
                var badgeNumber = 0;

                this.dataFilter.filter(function(item) {                    
                    if(item.value && item.field != "Status"){
                        badgeNumber++;
                    }
                });

                return badgeNumber;
            }
        },
    }
</script>

<style #scoped>
    .p-card .p-card-content{
        margin:0!important;
        padding: 0 !important;
    }
</style>